import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { routing } from './routing';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
      RouterModule.forRoot(routing, {})
  ]
})
export class RoutingModule { }
